<template>
    <b-alert v-if="alert" :show="!!alert.message" variant="danger">
        {{ alert.message }} 
        <template v-if="alert.errors">
            <span v-for="(error, index) in alert.errors" :key="index"> {{ error[0] }}</span>
        </template>
    </b-alert>
</template>

<script>
  export default {
    props: [ 'alert' ],
    data() {
        return {}
    },
    methods: {}
  }
</script>
